import React, { Component } from "react";
import GetProducts from "../../services/applications";
import MetaDecorator from "../../services/MetaDecorator";
import blog from "../../../media/images/blog.jpg";
import blogMobile from "../../../media/images/blogMobile.jpg";

export class Products extends Component {
  constructor(props) {
    super(props);
    this.websites = React.createRef();
    this.state = {
      width: window.innerWidth,
    };
  }

  componentDidMount = () => {
    let tabs = document
      .getElementsByClassName("nav-wrapper")[1]
      .querySelectorAll("ul")[0]
      .querySelectorAll("a");
    for (let i = 0; i < tabs.length; i++) {
      tabs[i].removeAttribute("class");

      if (tabs[i].id === "products") {
        tabs[i].setAttribute("class", "orange-text text-darken-4");
      }
    }

    let mobileTabs = document
      .getElementsByClassName("sidenav")[0]
      .querySelectorAll("a");
    for (let i = 0; i < mobileTabs.length; i++) {
      if (mobileTabs[i].id === "productsMobile") {
        mobileTabs[i].removeAttribute("class");
        mobileTabs[i].setAttribute(
          "class",
          "orange-text text-darken-4 grey darken-3",
        );
      }
    }

    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions.bind(this));

    if (document.referrer.indexOf("fokusbereiche/webseiten") !== -1) {
      this.websites.current.scrollIntoView();
    }
  };

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth });
  };

  render() {
    const { width } = this.state;
    const isMobile = width <= 600;
    const isTablet = width <= 992 && width > 600;
    return (
      <React.Fragment>
        <MetaDecorator
          title="JetMinds | Produkte"
          descrption="unsere ready-to-start Produkte helfen Ihrem Unternehmen effizient und schnell Ihre Prozesse zu digitalisieren, Routinetätigkeiten zu minimieren um produktiver zu werden"
          url="https://www.jetminds.de/produkte/"
        />
        <div className="pageImageTitle">
          {isMobile ? (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blogMobile}
              alt="JetMinds Produkte"
              loading="lazy"
            />
          ) : (
            <img
              className="responsive-img"
              style={{ width: "100%" }}
              src={blog}
              alt="JetMinds Produkte"
              loading="lazy"
            />
          )}
          {isMobile || isTablet ? (
            <div className="imgTxtMobile">
              <h1
                className={`white-text ${isTablet ? "isTablet" : "isMobile"}`}
              >
                Produkte
              </h1>
            </div>
          ) : (
            <div className="imgTxt">
              <h1 className="white-text">Produkte</h1>
            </div>
          )}
        </div>
        <div className="container">
          <div className="section">
            <div className="row">
              <div className="col s12 m12">
                <h1 className={`${isMobile ? "pageTitleM" : "pageTitle"}`}>
                  Flexibler, leistungsstarker und{" "}
                  <span className="orange-text text-darken-4">
                    ergebnisreicher
                  </span>{" "}
                  durch{" "}
                  <span className="orange-text text-darken-4">
                    schnellen Einstieg
                  </span>{" "}
                  in die digitalisierte Zusammenarbeit
                </h1>
              </div>
            </div>
            <div className="row"></div>
          </div>
          <GetProducts isTablet={isTablet} isMobile={isMobile} />
        </div>
      </React.Fragment>
    );
  }
}

export default Products;



// WEBPACK FOOTER //
// ./src/components/layout/pages/Products.js